<template>
  <div class="form-group">
    <label
      v-if="label != null"
      class="control-label col-sm-2"
      :for="id"
    > {{ label }} </label>
    <div :class="{ 'has-error': hasErrorMessage(), 'col-sm-10': label != null }">
      <query-date-picker
        :id="id"
        :value="value"
        style="width:100%"
        :placeholder="placeholder"
        @input="$emit('input', $event)"
      />
      <span
        v-if="hasErrorMessage()"
        class="help-block"
      >
        <strong>{{ this.errormessage }}</strong>
      </span>
    </div>
  </div>
</template>

<script>
import QueryDatePicker from '../QueryDatePicker.vue'

export default {
  name: 'DatePickerComponent',
  components: { QueryDatePicker },
  props: {
    id: {
      required: true,
    },
    label: {
      required: false,
      type: String,
      default: null,
    },
    errormessage: {

      default: null,
    },
    value: '',
    placeholder: {
      required: false,
      type: String,
      default: null,
    },
  },

  methods: {
    hasErrorMessage () {
      return this.errormessage !== null
    },

  },
}
</script>

<style>

    .el-date-editor
    {
        width:100% !important;;
    }
</style>
